import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
    openQuoteRevision
} from '../../store/quotesAndNotificationsSlice';
import {
    setSidePanelTitle,
    setCurrentPage
} from '../../store/pageLayoutSlice';
import './Quotes.css';

function RevisionMessages(props){

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch( setSidePanelTitle('Messages') )
    }, [ dispatch ]);

    const {
        suggestions,
        modifications,
        activeQuote,
        canRevise,
        denialReason,
        flags
    } = props;

    let user;
    if( denialReason ){
        flags.forEach(flag => {
            if( flag.status.toLowerCase() === 'denied' ){
                user = flag.approvedBy.userName ? flag.approvedBy.userName : flag.approvedBy.role;
            }
        });
    }

    return (
        <div className="quotes_sp_revisionInfo">
            {
                !denialReason &&
                modifications.map( (modification, i) => {
                    return (
                        <div className="modification_sp_container" key={ modification.modification }>
                            <p className="modification_sp_label">{ modification.userName } has required the following changes:</p>
                            <p className="modification_sp_paragraph">{ modification.modification }</p>
                        </div>
                    );
                })
            }
            {
                !denialReason &&
                suggestions.map( (suggestion, i) => {
                    return (
                        <div className="modification_sp_container" key={ suggestion.suggestion }>
                            <p className="modification_sp_label">{ suggestion.userName } has suggested the following changes:</p>
                            <p className="modification_sp_paragraph">{ suggestion.suggestion }</p>
                        </div>
                    );
                })
            }
            {
                denialReason && user &&
                <div className="modification_sp_container" >
                    <p className="modification_sp_label">{ user } has denied this quote for the following reason(s):</p>
                    <p className="modification_sp_paragraph">{ denialReason }</p>
                </div>
            }
            {
                !denialReason && suggestions.length === 0 && modifications.length === 0 &&
                <div>
                    <p style={{textAlign: 'left'}}>There are currently no messages for this quote.</p>
                </div>
            }
            {
                canRevise && activeQuote &&
                <button
                    className="create_revision_button"
                    onClick={ () => {
                            dispatch( openQuoteRevision({ quote: activeQuote }) );
                            dispatch( setCurrentPage( "Create Quote" ) );
                        }
                    }
                >
                    Create Revision
                </button>
            }
        </div>
    );
}

export default RevisionMessages;
